/**
 * Client-side variant config bridge.
 *
 * `window.APP_VARIANT` and `window.__VARIANT_CONFIG__` are set in the layout
 * EJS (apps.ejs, header.ejs) before the React bundle loads. Read variant data
 * through this module rather than hardcoding the variant name in checks —
 * a typo in `=== 'keywordgraph'` fails silently to default behavior.
 */

const FALLBACK_CONFIG = {
    variant: 'infranodus',
    brand: {
        productName: 'InfraNodus',
        siteLabel: 'InfraNodus.Com',
        signupSourceUrl: 'https://infranodus.com/signup',
        marketingDomain: 'https://infranodus.com',
    },
    trackers: {
        gtmId: null,
        gtagId: null,
        mixpanelToken: null,
        mixpanelOptions: {},
        posthogKey: null,
        posthogHost: null,
        hotjar: null,
        firstPromoter: null,
    },
    plans: { tiers: {}, planAmounts: {} },
}

export function getVariantConfig() {
    if (typeof window === 'undefined') return FALLBACK_CONFIG
    return window.__VARIANT_CONFIG__ || FALLBACK_CONFIG
}

export function getVariantName() {
    return getVariantConfig().variant
}

export function isKeywordGraphApp() {
    return getVariantName() === 'keywordgraph'
}

export function appProductName() {
    return getVariantConfig().brand.productName
}

export function appMarketingSiteLabel() {
    return getVariantConfig().brand.siteLabel
}
